import clsx from 'clsx';
import {useState} from 'preact/hooks';
import React, {ReactType} from 'react';
import FilePlayer from 'react-player/lib/players/FilePlayer';
import YouTube from 'react-player/lib/players/YouTube';
import defaultTheme from './video-player.module.pcss';
import {YoutubePoster} from './youtube-poster';

export type Props = {
  /**
   * Element node
   * @default 'div'
   */
  as?: ReactType;
  url: string;
  loaded?: boolean;
  poster?: boolean;
  className?: string;
  theme?: {
    root?: string;
    player?: string;
    poster?: string;
  };
};

export const VideoPlayer = ({
  as: ComponentProp = 'div',
  className,
  url,
  theme = defaultTheme,
  loaded = true,
  poster = false,
  ...rest
}: Props) => {
  const [active, setActive] = useState(loaded);
  const handleClick = () => setActive(true);

  if (url.includes('shopify')) {
    return (
      <ComponentProp className={clsx(theme.root, className)} {...rest}>
        <FilePlayer
          url={url}
          className={theme.player}
          height="100%"
          width="100%"
          config={{
            file: {
              attributes: {
                autoplay: true,
                controls: true,
                playsinline: true,
                poster: true,
              },
            },
          }}
        />
      </ComponentProp>
    );
  } else {
    return (
      <ComponentProp className={clsx(theme.root, className)} {...rest}>
        {poster && (
          <YoutubePoster
            url={url}
            clickHandler={handleClick}
            className={theme.poster}
          />
        )}

        {active && (
          <YouTube
            url={url}
            className={theme.player}
            height="100%"
            width="100%"
            volume="1"
            muted="true"
            playsinline
            config={{
              youtube: {
                playerVars: {
                  autoplay: 1,
                  controls: 0,
                  rel: 0,
                },
              },
            }}
          />
        )}
      </ComponentProp>
    );
  }
};
